module.exports = __webpack_public_path__ + "img/ai.360b990d.png";